export default "__VITE_ASSET__DWBBbg7m__"